import React from "react";
import CompareCarSlider from "./compareCarSlider";
import { Button } from "antd";
import { green } from "../../constants/colors";
import bg from "../../assets/images/compire-bg.png";
import { useNavigate } from "react-router-dom";
const CompareCar = () => {
  const navigate = useNavigate();
  return (
    <div
      className="min-h-[80vh] md:min-h-[90vh] mb-20"
      style={{
        backgroundImage: `linear-gradient(rgba(0,0,0,.5),rgba(0,0,0,.5)),url(${bg})`,
        backgroundRepeat: "no-repeat",
        backgroundPosition: "center",
        backgroundSize: "cover",
      }}
    >
      <CompareCarSlider />
      <div className="text-center md:text-[unset] md:flex justify-center items-center gap-2 mb-4 -mt-10 md:mt-[unset]">
        {/* <p className="text-[16px] tracking-wide text-[white]">
          Thousand of People Reviews to Us
        </p> */}
        <Button
          style={{
            background: "transparent",
            border: "none",
            boxShadow: "none",
            fontWeight: 500,
            color: green,
          }}
          onClick={()=>navigate("/compare")}
        >
          All Car Comparisons
        </Button>
      </div>
    </div>
  );
};

export default CompareCar;
